import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-contact-us',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule],
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent {
  contactData = {
    name: '',
    email: '',
    subject: 'general',
    message: ''
  };
  isSending = false;
  successMessage = '';
  errorMessage = '';

  sendMessage() {
    if (this.isSending) return;
    if (!this.contactData.name || !this.contactData.email || !this.contactData.message) {
      this.errorMessage = 'Please fill in all required fields.';
      return;
    }
    this.isSending = true;
    this.successMessage = '';
    this.errorMessage = '';

    setTimeout(() => {
      this.isSending = false;
      this.successMessage = 'Message sent! We\'ll get back to you within a few hours.';
      this.contactData = { name: '', email: '', subject: 'general', message: '' };
      setTimeout(() => this.successMessage = '', 5000);
    }, 800);
  }
}
